
import $ from 'jquery';
import config from '../../../config';

export function get_carryforward(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'ind_carryforward/',
			data: {
                method: 'GET_CARRYFORWARS'
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_CARRYFORWARS",
				ind_carryforward: response
			})
		})

	}
}

export function get_users(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'ind_carryforward/',
			data: {
                method: 'GET_CARRYFORWARS_USERS'
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_CARRYFORWARS_USERS",
				ind_carryforward: response
			})
		})

	}
}

export function save_carryforward( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'ind_carryforward/',
			data: {
                method: 'SAVE_CARRYFORWARS',
                data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_CARRYFORWARS",
				ind_carryforward: response
			})
		})

	}
}

export function delete_carryforward( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'ind_carryforward/',
			data: {
                method: 'DELETE_CARRYFORWARS',
                id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_CARRYFORWARS",
				ind_carryforward: response
			})
		})

	}
}

export function update_carryforward( id, text, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'ind_carryforward/',
			data: {
                method: 'UPDATE_CARRYFORWARS',
                id: id,
                text: text,
                value: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_CARRYFORWARS",
				ind_carryforward: response
			})
		})

	}
}



// WEBPACK FOOTER //
// ./src/pages/individual_carry_forwards/actions/carry.action.js